import axios from "axios";
import {
  FETCH_TARIFF,
  HANDLE_ERRORS,
  LOADING_MODE
} from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const getTariffInfo = () => async (dispatch) => {
  dispatch({ type: LOADING_MODE, payload: true });

  const response = await axios.get(
    `${BASE_URL}/api/file/peak_tariff_info_date`,
    authorizeRequest()
  );

  dispatch({
    type: HANDLE_ERRORS,
    payload: { message: '', open: false }
  });

  if (response.data.error) {
    console.error("Error fetching tariff info:", response.data.error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: response.data.error, open: true }
    });
  } else {
    await dispatch({
      type: FETCH_TARIFF,
      payload: response
    });
  }

  dispatch({ type: LOADING_MODE, payload: false });
};



// WEBPACK FOOTER //
// ./src/actions/getTariffInfo.js